/**
 * 获取1小时降雨
 */
export function getYQReportOption (option) {
  return {
    grid: {
      left: 50,
      right: 30,
      top: 30,
      bottom: 30
    },
    tooltip: {
      trigger: 'axis'
    },
    xAxis: {
      type: 'category',
      axisTick: {
        show: false
      },
      axisLabel: {
        color: '#FFF',
        fontSize: '0.9rem'
      },
      data: ['当月', '龙舟水', '同比', '当年', '常年']
    },
    yAxis: {
      type: 'value',
      name: '（mm）',
      nameTextStyle: {
        fontSize: '0.9rem',
        align: 'right',
        color: '#FFF'
      },
      splitLine: {
        show: false
      },
      axisLabel: {
        color: '#FFF',
        fontSize: '0.9rem'
      }
    },
    series: [
      {
        name: '雨量',
        data: [12, 7, 17, 13, 25],
        type: 'bar',
        barWidth: 24,
        showBackground: true,
        backgroundStyle: {
          color: 'rgba(31, 44, 73, 0.87)',
          borderRadius: 10
        },
        itemStyle: {
          normal: {
            borderRadius: [10, 10, 0, 0],
            color: function (params) {
              const color = {
                type: 'linear',
                x: 0,
                y: 1,
                x2: 0,
                y2: 0,
                colorStops: [
                  {
                    offset: 0,
                    color: '#2D74F5'
                  },
                  {
                    offset: 1,
                    color: '#53A4FA'
                  }
                ],
                global: false
              }
              const color1 = {
                type: 'linear',
                x: 0,
                y: 1,
                x2: 0,
                y2: 0,
                colorStops: [
                  {
                    offset: 0,
                    color: '#FFA32B'
                  },
                  {
                    offset: 1,
                    color: '#FFC673'
                  }
                ],
                global: false
              }
              return params.dataIndex % 2 === 0 ? color : color1
            }
          }
        }
      }
    ]
  }
}
